import { useEffect, useState } from "react";
import { listScans } from "@/lib/api";

export default function History() {
  const [scans, setScans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setScans(await listScans());
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div data-testid="history-page" className="px-6 lg:px-10 py-8 max-w-[1500px] mx-auto">
      <div className="font-mono text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">
        // OPERATION LOG
      </div>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-white mb-3 leading-none">
        Scan history
      </h1>
      <p className="text-zinc-400 mb-10 text-sm max-w-xl">
        Every recon sweep you've launched. Older scans stay archived so you can
        compare niche shifts over time.
      </p>

      {loading ? (
        <div className="font-mono text-sm text-zinc-500">
          [recon] retrieving log<span className="blink">_</span>
        </div>
      ) : scans.length === 0 ? (
        <div className="border border-dashed border-zinc-800 rounded-sm p-12 text-center bg-zinc-950">
          <div className="font-mono text-yellow-400 text-xs uppercase tracking-[0.3em] mb-4">
            [ NO OPERATIONS LOGGED ]
          </div>
          <p className="text-zinc-400 text-sm">
            Run your first scan from the dashboard.
          </p>
        </div>
      ) : (
        <div className="border border-zinc-800 rounded-sm overflow-hidden">
          <div className="grid grid-cols-12 px-4 py-3 bg-zinc-950 border-b border-zinc-800 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">
            <div className="col-span-5">Scan ID</div>
            <div className="col-span-3">Run at</div>
            <div className="col-span-2 text-right">Videos</div>
            <div className="col-span-2 text-right">Niches</div>
          </div>
          {scans.map((s) => (
            <div
              key={s.scan_id}
              data-testid={`scan-row-${s.scan_id}`}
              className="grid grid-cols-12 px-4 py-3 border-b border-zinc-900 last:border-b-0 hover:bg-zinc-950 transition-colors items-center"
            >
              <div className="col-span-5 font-mono text-sm text-white truncate">
                {s.scan_id}{" "}
                <span
                  className={`ml-2 font-mono text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded-sm border ${
                    s.status === "complete"
                      ? "border-green-500/50 text-green-400"
                      : s.status === "failed"
                      ? "border-red-500/50 text-red-400"
                      : "border-yellow-400/50 text-yellow-400"
                  }`}
                >
                  {s.status}
                </span>
              </div>
              <div className="col-span-3 font-mono text-xs text-zinc-400">
                {new Date(s.created_at).toLocaleString()}
              </div>
              <div className="col-span-2 font-mono text-sm text-zinc-300 text-right">
                {s.video_count}
              </div>
              <div className="col-span-2 font-mono text-sm text-yellow-400 text-right">
                {s.niche_count}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
